import { call, put, select } from 'redux-saga/effects';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceBase } from '../../../datasource/models/IDataSourceInfo';
import { ChangeRemoteExtractRefreshExpectedDurationAction } from '../../actions/remoteExtractRefresh/ChangeRemoteExtractRefreshExpectedDurationAction';
import { IRemoteRefreshScheduleInfo } from '../../models/IRemoteRefreshScheduleInfo';
import { EditRemoteRefreshExpectedDurationAction } from '../../services/EditRemoteRefreshExpectedDurationAction';

export function* handleChangeRemoteExtractRefreshExpectedDurationAction(action: ChangeRemoteExtractRefreshExpectedDurationAction) {
  try {
    const datasource: IDataSourceBase = yield select(selectSpaceInfoItem);
    yield call(executeChangeRemoteExtractRefreshExpectedDurationAction, datasource, action.scheduleInfo);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeRemoteExtractRefreshExpectedDurationAction(
  datasource: IDataSourceBase,
  item: IRemoteRefreshScheduleInfo
) {
  return EditRemoteRefreshExpectedDurationAction.execute(datasource, item);
}
